<div class="filters">

  <button class="filters__sort" (click)="toggleOptions()">
    <svg [ngClass]="{'rotate': sortOrder === sortingOrder.ASC}" width="24" height="24">
      <use xlink:href="#filters-i"/>
    </svg>
  </button>

  <div class="filters__info">
    <p>Sorted by <span class="capitalize">{{ sortBy }}</span></p>
    <p *ngIf="searchStrSaved">Search results for <b>"{{ searchStrSaved }}"</b></p>
  </div>

  <button class="filters__search" (click)="toggleSearch()">
    <svg *ngIf="!visibleSearch" width="24" height="24">
      <use xlink:href="#search-i"/>
    </svg>
    <svg *ngIf="visibleSearch" width="24" height="24">
      <use xlink:href="#check-i"/>
    </svg>
  </button>

  <div class="filters__options" [ngClass]="{'visible': visibleOptions}">
    <span *ngFor="let option of options"
          matRipple
          class="options-item"
          [ngClass]="{'active': option.id === activeOption}"
          (click)="selectOption(option.id)">{{ option.title }}</span>
  </div>

  <div class="filters__search-input" [ngClass]="{'visible': visibleSearch}">
    <input class="input" type="text" [(ngModel)]="searchStr">
    <button class="clear" *ngIf="searchStr" (click)="clearSearch()">
      <svg width="12" height="12">
        <use xlink:href="#cross-i"/>
      </svg>
    </button>
  </div>
</div>
